import * as Yup from 'yup'
import {TabOption} from '../../../../shared/components/FormTabHeader'
import {BaseEntity} from '../../../../shared/models/ApiModels'

export interface ICarMTVModel extends BaseEntity {
  carMTVDescription: ICarMTVDescriptionModel
  carMTVPayment: ICarMTVPaymentModel
}

export interface ICarMTVDescriptionModel extends BaseEntity {
  accrualDate: Date | string
  accrualPeriod: string
  amount: number
  currency: string
  exchangeRate: number
  remaining: number
  licensePlate: string
  expenseName: string
  transactionBranch: string
  documentNo: string
  processedBy: string
  institutionName: string
}

export interface ICarMTVPaymentModel extends BaseEntity {
  paymentDate: Date | string
  paymentAmount: number
  currency: string
  exchangeRate: number
  paymentType: string
  cashRegisterCode: string
  iban: string
  description: string
}

export const initialCarMTVDescription: ICarMTVDescriptionModel = {
  accrualDate: '',
  accrualPeriod: '',
  amount: 0,
  currency: '',
  exchangeRate: 0,
  remaining: 0,
  licensePlate: '',
  expenseName: '',
  transactionBranch: '',
  documentNo: '',
  processedBy: '',
  institutionName: '',
}

export const initialCarMTVPayment: ICarMTVPaymentModel = {
  paymentDate: '',
  paymentAmount: 0,
  currency: '',
  exchangeRate: 0,
  paymentType: '',
  cashRegisterCode: '',
  iban: '',
  description: '',
}

export const initialCarMTV: ICarMTVModel = {
  carMTVDescription: initialCarMTVDescription,
  carMTVPayment: initialCarMTVPayment,
}

export const validationCarMTV = Yup.object().shape({})

export const tabOptions: TabOption<'description' | 'payment'>[] = [
  {key: 'description', title: 'Bilgi Giriş', icon: 'bi bi-geo-alt'},
  {key: 'payment', title: 'Ödeme', icon: 'bi bi-list'},
]

export const EXPENSE_NAME = [{value: 'MTV', label: 'MTV'}] as const

export const ACCRUAL_PERIOD = [{value: '0', label: '2025-2'}] as const

export const CURRENCY = [{value: '0', label: 'TL'}] as const

export const PAYMENT_TYPE = [{value: 'Nakit', label: 'Nakit'}] as const

export const CASH_REGISTER_CODE = [{value: 'MERKEZ', label: 'MERKEZ'}] as const

export const IBAN = [{value: 'ŞAHSİ HESAP -- TL', label: 'ŞAHSİ HESAP -- TL'}] as const
